export const getPropTypesFetching = (state) => state?.propsWidget?.fetching || false;

// eslint-disable-next-line react/forbid-foreign-prop-types
export const getPropTypes = (state) => state?.propsWidget?.propTypes || [];
